<template>
  <div class="template-manage">
    <div class="temp-title">
      <el-button 
        size="small" 
        type="primary"
        icon="el-icon-circle-plus-outline"
        @click="addTemp">新增项目</el-button>
    </div>
    <div class="temp-list">
      <el-table
        class="template-list"
        :data="tempList"
        style="width: 100%">
        <el-table-column
          label="消费满">
          <template slot-scope="scope">
            <div v-if="!scope.row.editing">
              <span>{{ scope.row.limitConsumeValue }}</span>
            </div>
            <div v-else>
              <el-input v-model="scope.row.limitConsumeValue" placeholder="消费满x元"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="送优惠券包">
          <template slot-scope="scope">
            <div v-if="!scope.row.editing">
              <span>{{ scope.row.name }}</span>
            </div>
            <div v-else>
              <el-select v-model="scope.row.itemId" placeholder="代金券包">
                <el-option
                  v-for="item in couponPackages"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <div class="operate-groups">
              <el-button
                type="primary"
                size="mini"
                v-if="!scope.row.editing"
                icon="el-icon-edit-outline"
                @click="handleEdit(scope.$index, scope.row)">编辑
              </el-button>
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.editing"
                icon="el-icon-success"
                @click="handleSave(scope.$index, scope.row)">保存
              </el-button>
              <el-button
                size="mini"
                type="danger"
                v-if="!scope.row.editing"
                icon="el-icon-delete"
                @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>
              <el-button
                size="mini"
                type="warning"
                v-if="scope.row.editing"
                icon="el-icon-warning"
                @click="handleCancel(scope.$index, scope.row)">取消
              </el-button>
              <!-- <div class="upAndDown">
                <el-button 
                  plain 
                  class="up" 
                  type="primary" 
                  size="mini"
                  icon="el-icon-arrow-up"
                  @click="handleUp(scope.$index, scope.row)">
                </el-button>
                <el-button 
                  plain   
                  class="down" 
                  type="primary" 
                  size="mini" 
                  icon="el-icon-arrow-down"
                  @click="handleDown(scope.$index, scope.row)">
                </el-button>
              </div> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script  type='text/ecmascript-6'>

export default {
  props:{
    floorData: {
      type: Array,
      default () {
        return []
      }
    },
    couponPackages:{
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      tempList:[],
    }
  },
  watch:{
    floorData:{
      deep: true,
      immediate: true,
      handler: function(o,u) {
        this.tempList = o
      }
    }
  },
  created () {
    
  },
  mounted(){
  },
  methods: {
    // 上下自由调整表格数据
    swapItems (arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      return arr
    },
    handleUp ($index, row) {
      if ($index === 0) {
        return
      }
      this.swapItems(this.tempList, $index, $index - 1)
    },
    handleDown ($index, row) {
      if ($index === this.tempList.length - 1) {
        return
      }
      this.swapItems(this.tempList, $index, $index + 1)
    },
    // 编辑
    handleEdit ($index, row) {
      this.$set(this.tempList[$index], 'editing', true)
    },
    // 保存
    handleSave ($index, row) {
      this.$set(this.tempList[$index], 'editing', false)
      var coupon= this.couponPackages.find(c=>c.id==row.itemId)
      this.$set(this.tempList[$index], 'name', coupon.name)
      this.$emit('UpdateItems',this.tempList)
    },
    // 取消
    handleCancel ($index, row) {
      this.$set(this.tempList[$index], 'editing', false)
    },
    // 新增一条模板数据
    addTemp () {
      this.tempList = this.tempList || []
      this.tempList.push({
        limitConsumeValue: '',
        itemId: '',
        name: '',
        editing: true
      })
    },
    // 删除
    handleDelete ($index, row) {
      this.$confirm('此操作将永久删除该条模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tempList.splice($index, 1)
        // localStorage.setItem('tempList', JSON.stringify(this.tempList))
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch((err) => {
        this.$message({
          type: 'error',
          message: err
        })
      })
    }

  }
}
</script>
